import { motion, useReducedMotion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Steam } from "./Steam";
import { HERO_IMAGE } from "../data/site";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  const reduced = useReducedMotion();
  const fade = (delay) =>
    reduced
      ? {}
      : {
          initial: { opacity: 0, y: 20 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.7, delay, ease: [0.22, 0.61, 0.36, 1] },
        };

  return (
    <section
      id="hero"
      className="relative min-h-[100svh] overflow-hidden bg-[#2E2E2C]"
      data-testid="hero-section"
    >
      {/* Kuva: mobiilissa koko ruudun taustana, työpöydällä oikeassa puolikkaassa */}
      <div className="absolute inset-0 lg:left-[46%]">
        <img
          src={HERO_IMAGE}
          alt="Hengähdyksen valoisa oleskelutila ja pöytäryhmät Porvoon Pappilanmäellä"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2E2E2C] via-[#2E2E2C]/70 to-[#2E2E2C]/45 lg:bg-gradient-to-r lg:from-[#2E2E2C] lg:via-[#2E2E2C]/35 lg:to-[#2E2E2C]/10" />
      </div>
      <Steam />

      <div className="relative flex min-h-[100svh] items-end lg:items-center">
        <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-24 sm:pb-28 lg:pb-0">
          <div className="lg:max-w-[46%]">
            <motion.h1
              {...fade(0.15)}
              className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#F7F4EE]"
            >
              Hengähdys — sauna ja tila Porvoossa
            </motion.h1>
            <motion.p {...fade(0.34)} className="mt-6 max-w-xl text-base md:text-lg text-[#F7F4EE]/80 leading-relaxed">
              60-neliöinen juhlatila ja tilava sauna Vanhan kaupungin kupeessa Pappilanmäellä.
            </motion.p>
            <motion.div {...fade(0.46)} className="mt-10 flex flex-wrap items-center gap-4">
              <button
                type="button"
                onClick={() => scrollTo("varaus")}
                data-testid="hero-cta-button"
                className="rounded-full bg-[#8A9B87] px-8 py-4 text-sm font-medium tracking-wide text-white transition-colors duration-300 hover:bg-[#A9805B]"
              >
                Kysy vapaita aikoja
              </button>
              <button
                type="button"
                onClick={() => scrollTo("hinnasto")}
                data-testid="hero-pricing-link"
                className="rounded-full border border-[#F7F4EE]/40 px-8 py-4 text-sm font-medium tracking-wide text-[#F7F4EE] transition-colors duration-300 hover:bg-[#F7F4EE]/10"
              >
                Katso hinnat
              </button>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="scroll-hint absolute bottom-6 left-1/2 -translate-x-1/2 text-[#F7F4EE]/70 lg:left-12 lg:translate-x-0">
        <span className="block">
          <ChevronDown size={22} strokeWidth={1.5} />
        </span>
      </div>
    </section>
  );
};
